// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c26bf20","455":"d9689e67","977":"0bb3d4cb"}[chunkId] + ".chunk.js";
};